export interface CertificateDate {
  validFrom: string
  validTo: string
  validFor: number
}

export interface Certificate {
  id: number
  name: string
  slug: CertificateSlug
  dates: CertificateDate[]
}

export enum CertificateSlug {
  social = 'socijalni-mediji-i-marketing',
  digital = 'digitalna-transformacija',
  trainer = 'trener',
  security = 'bezbednost',
  ai = 'vestacka-inteligencija',
}
